import React from "react";
import Select from "../../../../form/select/Select";
const FONT_FAMILIES = [
  "Inter",
  "Arial",
  "Helvetica",
  "Times New Roman",
  "Georgia",
  "Courier New",
  "Verdana",
];

const FontFamilySelector = ({ fontFamilies, editor }) => {
  return (
    <div className="w-36">
      <Select
        dropdownButtonClass={"h-9"}
        dropdownData={[...FONT_FAMILIES, ...(fontFamilies || [])]?.map(
          (font) => ({
            name: font,
            value: font,
            style: { fontFamily: font },
          })
        )}
        buttonStyle={(val) => ({ fontFamily: `${val?.value}` })}
        selectedValue={editor.getAttributes("textStyle")?.fontFamily || "Inter"}
        checked={false}
        onChange={(val) => {
          editor.chain().focus().setFontFamily(val).run();
        }}
      />
    </div>
  );
};

export default FontFamilySelector;
